window.VideoCarousel = window.VideoCarousel || class VideoCarousel {
  #track;
  #cards;
  #prevBtn;
  #nextBtn;
  #trigger;
  #isTouch;

  constructor(container) {
    this.container = container;
    this.#track = container.querySelector('[data-carousel-track]');
    this.#cards = [...container.querySelectorAll('[data-video-card]')];
    this.#prevBtn = container.querySelector('[data-carousel-prev]');
    this.#nextBtn = container.querySelector('[data-carousel-next]');
    this.#trigger = container.dataset.playTrigger || 'hover';
    this.#isTouch = window.matchMedia('(hover: none)').matches;
    this.#init();
  }

  #init() {
    this.#bindCards();
    this.#bindArrows();
    this.#bindScrollState();
  }

  #bindCards() {
    for (const card of this.#cards) {
      const video = card.querySelector('video');
      if (!video) continue;

      if (this.#trigger === 'hover' && !this.#isTouch) {
        card.addEventListener('mouseenter', () => this.#play(card, video));
        card.addEventListener('mouseleave', () => this.#pause(card, video));
      }

      card.addEventListener('click', () => {
        if (card.classList.contains('is-playing')) {
          this.#pause(card, video);
        } else {
          this.#play(card, video);
        }
      });
    }
  }

  #loadSources(video) {
    if (video.querySelector('source[src]')) return;
    for (const source of video.querySelectorAll('source[data-src]')) {
      source.setAttribute('src', source.dataset.src);
    }
    video.load();
  }

  #play(card, video) {
    this.#loadSources(video);
    video.play().catch(() => {});
    card.classList.add('is-playing');
    card.querySelector('[data-play-btn]')?.setAttribute('aria-label', 'Pausar video');
  }

  #pause(card, video) {
    video.pause();
    card.classList.remove('is-playing');
    card.querySelector('[data-play-btn]')?.setAttribute('aria-label', 'Reproducir video');
  }

  #bindArrows() {
    if (!this.#prevBtn || !this.#nextBtn) return;
    this.#prevBtn.addEventListener('click', () => this.#scrollBy(-1));
    this.#nextBtn.addEventListener('click', () => this.#scrollBy(1));
  }

  #scrollBy(direction) {
    const slide = this.#track.querySelector('.video-carousel__slide');
    if (!slide) return;
    const gap = parseInt(getComputedStyle(this.#track).gap) || 0;
    const step = (slide.offsetWidth + gap) * 2;
    this.#track.scrollBy({ left: direction * step, behavior: 'smooth' });
  }

  #bindScrollState() {
    if (!this.#prevBtn || !this.#nextBtn) return;
    const update = () => {
      const { scrollLeft, scrollWidth, clientWidth } = this.#track;
      this.#prevBtn.disabled = scrollLeft <= 0;
      this.#nextBtn.disabled = scrollLeft + clientWidth >= scrollWidth - 1;
    };
    this.#track.addEventListener('scroll', update, { passive: true });
    update();
  }
};

const initVideoCarousels = (root = document) => {
  root.querySelectorAll('[data-video-carousel]').forEach((el) => {
    if (el.dataset.videoCarouselInitialized === 'true') return;
    el.dataset.videoCarouselInitialized = 'true';
    new window.VideoCarousel(el);
  });
};

initVideoCarousels();
